// externals
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// libraries
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as customerRiskAndCoverageActionCreators from '@makemydeal/dr-dash-store/actions/customerRiskAndCoverageActionCreators';
import * as dealXgDetailsSelectors from '@makemydeal/dr-dash-store/selectors/dealXgDetailsSelectors';
import * as compositeSelectors from '@makemydeal/dr-dash-store/selectors/compositeSelectors';
import { Action } from '@interstate/components/Action';
import { Typography } from '@interstate/components/Typography';

// components
import CustomerRiskAndCoverageSlideOut from '../vehicleInsurance/CustomerRiskAndCoverageSlideOut';
import { useValidationGuard } from '../hooks/useValidationGuard';

export type VehicleCompliantLinkProps = {
    children?: React.ReactNode;
    disabled?: boolean;
};

export const VehicleComplianceLink: React.FC<VehicleCompliantLinkProps> = ({ disabled = false }) => {
    const dispatch = useDispatch();
    const isEcommerceDeal = useSelector(dealXgDetailsSelectors.getIsEcommerceDeal);
    const slideOutMode = isEcommerceDeal ? 'compliance' : 'credit_bureau';
    const skipCtaValidation = useSelector(compositeSelectors.getIsTraditionalOrIntakeWithoutVehicle);
    const guard = useValidationGuard('exit', {
        skipValidationKeys: ['vehicle'],
        skipGuardValidation: skipCtaValidation
    });

    const handleComplianceClick = guard.wrap(() => {
        dispatch(baseDealActionCreators.setCustomerRiskAndCoverageTab(slideOutMode));
        dispatch(baseDealActionCreators.setCustomerRiskAndCoverageSlideOutStatus(true));
        dispatch(customerRiskAndCoverageActionCreators.customerRiskAndCoverageSlideOutButton());
    });
    return (
        <>
            <Typography
                variant="body-md"
                tag="span"
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '.4rem',
                    alignItems: 'center',
                    whiteSpace: 'nowrap',
                    marginTop: '2px'
                }}
            >
                <Action size="md" data-testid="vehicle-compliance-btn" disabled={disabled} onClick={handleComplianceClick}>
                    <span style={{ fontWeight: 400 }}>Compliance</span>
                </Action>
            </Typography>
            <CustomerRiskAndCoverageSlideOut mode={slideOutMode} />
        </>
    );
};
